import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { useContent } from "../lib/content";
import { Phone } from "lucide-react";

export default function ProductCard({ product }) {
  const { addItem } = useCart();
  const { content: c } = useContent();
  return (
    <div
      className="product-card group"
      data-testid={`product-card-${product.id}`}
    >
      <Link to={`/product/${product.id}`} className="block">
        <div className="image-zoom aspect-[4/5] bg-[var(--srishti-bg-alt)] relative">
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-full object-cover"
            loading="lazy"
          />
          {product.badge && (
            <span
              className="absolute top-3 left-3 bg-[var(--srishti-bg)] text-[var(--srishti-saffron)] text-[10px] uppercase tracking-widest font-semibold px-2.5 py-1"
              data-testid={`product-badge-${product.id}`}
            >
              {product.badge}
            </span>
          )}
        </div>
      </Link>
      <div className="px-4 py-4">
        <Link to={`/product/${product.id}`}>
          <h3 className="font-serif-display text-xl leading-tight text-[var(--srishti-text)] hover:text-[var(--srishti-maroon)] transition-colors">
            {product.name}
          </h3>
        </Link>
        <div className="mt-3 flex items-center justify-between gap-2">
          <a
            href={`tel:${(c.store_phone || "").replace(/\s+/g, "")}`}
            className="flex items-center gap-1.5 text-xs text-[var(--srishti-maroon)]"
            onClick={(e) => e.stopPropagation()}
            data-testid={`call-for-price-${product.id}`}
          >
            <Phone size={13} />
            <span className="font-semibold uppercase tracking-widest">Call for price</span>
          </a>
          <button
            className="text-[10px] uppercase tracking-widest font-semibold text-[var(--srishti-text-secondary)] hover:text-[var(--srishti-maroon)] transition-colors"
            onClick={(e) => {
              e.preventDefault();
              addItem(product);
            }}
            data-testid={`add-to-cart-${product.id}`}
          >
            Enquire +
          </button>
        </div>
      </div>
    </div>
  );
}
